import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { formatApiError } from "../lib/api";

export default function Profile() {
  const { user, updateProfile } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState({
    name: user?.name || "",
    email: user?.email || "",
    username: user?.username || "",
    current_password: "",
    new_password: "",
  });
  const [busy, setBusy] = useState(false);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = {
        name: form.name,
        email: form.email,
        username: form.username,
      };
      if (form.new_password) {
        payload.current_password = form.current_password;
        payload.new_password = form.new_password;
      }
      await updateProfile(payload);
      toast.success(t("profile.updated"));
      setForm((f) => ({ ...f, current_password: "", new_password: "" }));
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8">
      <p className="label-mini">{user?.role === "admin" ? "Administrator" : "Mitarbeiter"}</p>
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight leading-none mt-1 mb-6">{t("profile.title")}</h1>

      <form onSubmit={submit} className="swiss-card p-6 space-y-4" data-testid="profile-form">
        <Field label={t("profile.name")}>
          <Input value={form.name} onChange={(e) => set("name", e.target.value)} required data-testid="profile-name" style={{ borderRadius: 4 }} />
        </Field>
        <Field label={t("profile.email")}>
          <Input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} required data-testid="profile-email" style={{ borderRadius: 4 }} />
        </Field>
        <Field label={t("profile.username")}>
          <Input value={form.username} onChange={(e) => set("username", e.target.value)} required data-testid="profile-username" style={{ borderRadius: 4 }} />
        </Field>
        <div className="border-t border-border pt-4">
          <Field label={t("profile.currentPassword")}>
            <Input type="password" value={form.current_password} onChange={(e) => set("current_password", e.target.value)} data-testid="profile-current-password" style={{ borderRadius: 4 }} />
          </Field>
          <Field label={t("profile.newPassword")} className="mt-4">
            <Input type="password" value={form.new_password} onChange={(e) => set("new_password", e.target.value)} data-testid="profile-new-password" style={{ borderRadius: 4 }} />
          </Field>
        </div>
        <Button
          type="submit"
          disabled={busy}
          className="bg-[#0055FF] hover:bg-[#0044CC] text-white"
          style={{ borderRadius: 4 }}
          data-testid="profile-save-button"
        >
          {busy ? t("common.loading") : t("profile.save")}
        </Button>
      </form>
    </div>
  );
}

function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <Label className="label-mini mb-1.5 block">{label}</Label>
      {children}
    </div>
  );
}
